"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const AppBar_1 = tslib_1.__importDefault(require("@mui/material/AppBar"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const FallbackAppBarContactUs_1 = tslib_1.__importDefault(require("./FallbackAppBarContactUs"));
const FallbackAppBarLogin_1 = require("./FallbackAppBarLogin");
const FallbackAppBar = ({ children, logoSrc }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(AppBar_1.default, { component: "div", sx: {
            bgcolor: "#131313", // This should be a part of the theme. But we cant use theme.primary.main because this will be wrong on the NFCert pages.
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            height: "64px",
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        } },
        react_1.default.createElement(Box_1.default, { component: "img", sx: { p: 1.5, pl: 3 }, src: logoSrc }),
        react_1.default.createElement(Box_1.default, { sx: { margin: 1, display: "flex", flexDirection: "row" } },
            react_1.default.createElement(FallbackAppBarContactUs_1.default, null),
            react_1.default.createElement(FallbackAppBarLogin_1.FallbackAppBarLogin, null))),
    react_1.default.createElement(Box_1.default, { sx: {
            mt: "64px",
            ".MnePageLayoutWrapper": {
                height: "unset",
                marginTop: 0,
            },
        } }, children)));
exports.default = FallbackAppBar;
